// api/modules/product/repo.js
import { http, ep } from '../../client/http';

export const productRepo = {
  /**
   * options:
   *   - featuredOnly: true|false
   *   - status: true|false
   *   - limit: number
   */
  get: async ({ featuredOnly = false, status = true, limit = 1000 } = {}) => {
    const params = { status, limit };
    if (featuredOnly) params.isFeatured = true;

    const res = await http.get(ep('product/list'), { params });
    // Beklenen şekil: { total, products }
    return res.data.data;
  }
};